import React from 'react'
import Modal from "react-modal";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";

const StaffSelectedRunPayrollModel = ({openModal,afterOpenModal,closeModal,message}) => {
    let subtitle;

    return (
        <div>
            <Modal
                isOpen={openModal}
                // onAfterOpen={afterOpenModal}
                onRequestClose={closeModal}
                // style={customStyles}
                contentLabel="Example Modal"
                className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
            >
                <h2
                    ref={(_subtitle) => (subtitle = _subtitle)}
                    className="bg-[#F0F6FE] p-3 border-b rounded-b-none rounded-t-lg text-[14px]"
                >
                    No Staff Selected
                </h2>
                <button
                    onClick={closeModal}
                    className="top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold"
                >
                    <CloseIcon className="text-white" />
                </button>
                <div className="p-[10px] pb-2">
                    <div className="pt-[30px] pb-[30px] text-center">
                        <WarningIcon className="text-red-600 transition warning-icon" />
                        <p className="mt-3">{message}</p>
                    </div>

                    <div className="flex justify-end gap-[10px] p-2 border-t">
                        <button className="second-btn" onClick={closeModal}
                        >Okay</button>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default StaffSelectedRunPayrollModel